import { Component, Mixins, Vue } from 'vue-property-decorator'
import moment from 'moment'
import { State, Mutation } from 'vuex-class'
import html2canvas from 'html2canvas'
import { jsPDF } from 'jspdf'
import XLSX from 'js-xlsx'

@Component
export class myMixin extends Vue {
  @State(state => state.app.app_list)
  app_list
  @State(state => state.app.plat_list)
  plat_list
  @State(state => state.app.all_app_list)
  all_app_list
  //当天时间戳0:0
  private today = new Date(moment(new Date()).format('YYYY-MM-DD')).getTime()
  //不可用时间
  private dateOptions = {
    disabledDate: val => {
      let date = new Date(val).getTime()
      return date > this.today + 1000 * 60 * 60 * 24
    }
  }
  private GetBjTime(time) {
    return moment(time)
      .locale('zh-cn')
      .format('YYYY-MM-DD')
  }
  //头部
  private renderHeader(h, title, content) {
    return h(
      'Tooltip',
      {
        props: { placement: 'top', transfer: true, theme: 'light' }
      },
      [
        title,
        h(
          'span',
          {
            slot: 'content',
            style: { whiteSpace: 'normal', wordBreak: 'break-all' }
          },
          content
        )
      ]
    )
  }

  //计算金额：type=0 正常金额计算保留两位小数
  // type=1 金额/10000不保留两位小数
  // type=2 金额*10000不保留两位小数
  private getMoney(value, type = 0) {
    if (type == 0) {
      return value ? (parseFloat(value) / 10000).toFixed(2) : 0
    } else if (type == 1) {
      return value ? parseFloat(value) / 10000 : 0
    } else if (type == 2) {
      return value ? parseFloat(value) * 10000 : 0
    }
  }

  //屏幕判断
  private isMOble() {
    let num = document.documentElement.clientWidth < 737 ? 1 : 0
    return num
  }

  //计算比例
  private getRate(value) {
    let val = '0'
    if (value) {
      val = value + ' %'
    }
    return val
  }

  //获取秒数
  private getSecond(times, isStart: boolean = true) {
    let initTime = moment(times).format('YYYY-MM-DD')
    let other = isStart ? ' 00:00:00' : ' 23:59:59'
    return this.getSecondResult(initTime + other)
  }
  private getSecondResult(times) {
    return (
      Math.floor(moment(times).valueOf() / 1000) -
      (480 - moment().utcOffset()) * 60
    )
  }
  //简单验证
  private simpleVerify(message) {
    return (rule, value, callback) => {
      if (!value) {
        callback(message)
      } else {
        callback()
      }
    }
  }

  private getCustomFixed(val) {
    if (val == 0) return val
    if (!val) return 0
    let result = parseFloat(val).toFixed(2)
    if (parseInt(result) == parseFloat(result)) {
      return `${parseInt(result)}`
    } else {
      return result
    }
  }

  private publicLoading() {
    ;(this.$Spin as any).show({
      render: h => {
        return h('div', { style: { color: '#fff' } }, [
          h('Icon', {
            style: { animation: 'ani-demo-spin 1s linear infinite' },
            props: { type: 'ios-loading', size: 18 }
          }),
          h('div', { style: { 'margin-top': '10px' } }, '文件导出中...')
        ])
      }
    })
    setTimeout(() => {
      ;(this.$Spin as any).hide()
    }, 6000)
  }
  getStringLen(str) {
    if (!str) return 0
    var realLength = 0,
      len = str.length,
      charCode = -1
    for (var i = 0; i < len; i++) {
      charCode = str.charCodeAt(i)
      if (charCode > 0 && charCode <= 128) {
        realLength += 0.75
      } else {
        realLength += 1.75
      }
    }
    return realLength
  }

  //导出excel表格
  private eleToExcel(tables?) {
    // @ts-ignore
    let table = tables || this.$data.table || this.$parent.$data.table
    let data = table.data
    let columns = table.columns
    if (!data || data.length == 0) {
      return this.$Message.error('数据为空')
    }
    // @ts-ignore
    let ref: any = this.$refs.tableRef || this.$parent.$refs.tableRef
    // @ts-ignore
    let filename = `${
      this.$route.meta.title
    } ${new Date().toLocaleDateString()}`
    ref.exportCsv({
      filename,
      callback: csv => {
        let sheet = this.csv2sheet(csv, data, columns)
        let result = this.sheet2blob(sheet, filename)
        this.openDownloadDialog(result, `${filename}.xlsx`)
      }
    })
  }
  //导出excel表格
  private eleToExcel2({tables, fileName}) {
    // @ts-ignore
    let table = tables || this.$data.table || this.$parent.$data.table
    let data = table.data
    let columns = table.columns
    if (!data || data.length == 0) {
      return this.$Message.error('数据为空')
    }
    // @ts-ignore
    let ref: any = this.$refs.tableRef || this.$parent.$refs.tableRef
    // @ts-ignore
    let filename = `${
      this.$route.meta.title
    } ${fileName ? fileName : new Date().toLocaleDateString()}`
    ref.exportCsv({
      filename,
      callback: csv => {
        let sheet = this.csv2sheet(csv, data, columns)
        let result = this.sheet2blob(sheet, filename)
        this.openDownloadDialog(result, `${filename}.xlsx`)
      }
    })
  }

  private noTableCsvToXlsx(csv, filename) {
    var sheetStyle = {}
    let sheet = this.csvSheet(csv)
    let result = this.sheet2blob(sheet, filename)
    this.openDownloadDialog(result, `${filename}.xlsx`)
  }
  private csvSheet(csv) {
    var sheet = {}
    sheet['!cols'] = []
    csv = csv.split('\n')
    csv.forEach((row, i) => {
      row = row.split(',')
      if (i == 0) {
        sheet['!ref'] =
          'A1:' + this.getFromCode(65 + row.length - 1) + csv.length
      }
      row.forEach((col, j) => {
        let result = `${col}`.replace('%', '')
        let val: any = { v: Number(result) || result }
        let isPer = `${col}`.includes('%')
        if (!isNaN(Number(result))) {
          Object.assign(val, { t: 'n' })
          if (isPer) {
            val.v = parseFloat((val.v / 100).toFixed(4))
            Object.assign(val, { z: '0.00%' })
          }
        }
        sheet[this.getFromCode(65 + j) + (i + 1)] = val
        let len = isPer ? 6 : this.getStringLen(col) + 4
        if (len > (sheet['!cols'][j] || { wch: 0 }).wch) {
          sheet['!cols'][j] = { wch: len }
        }
      })
    })
    return sheet
  }
  getFromCode(code) {
    code = parseInt(code)
    if (code > 90) {
      let f = 65
      let count = 0
      do {
        code -= 26
        if (code <= 90) {
          break
        }
        count++
      } while (true)
      let a = String.fromCharCode(f + count)
      return a + String.fromCharCode(code)
    } else {
      return String.fromCharCode(code)
    }
  }
  csv2sheet(csv, data, columns) {
    var sheet = {}
    sheet['!cols'] = []
    csv = csv.split('\n')
    const h = this.$createElement
    csv.forEach((row, i) => {
      row = row.split(',')
      if (i == 0) {
        sheet['!ref'] =
          'A1:' + this.getFromCode(65 + row.length - 1) + csv.length
      }
      row.forEach((col, j) => {
        if (columns[j].key || columns[j].type == 'index') {
          let result = col
          if (i == 0) {
            let renderHeader = columns[j].renderHeader
            if (renderHeader) {
              let a: any = renderHeader(h)
              result = a.componentOptions.children[0].text || ''
            }
          } else {
            if (columns[j].type == 'index') {
              let render = columns[j].indexMethod
              if (render) {
                result = render(data[i - 1], j)
              } else {
                result = i
              }
            } else {
              let render = columns[j].render
              if (render) {
                let params = {
                  index: j,
                  column: columns[j],
                  row: data[i - 1]
                }
                let a: any = render(h, params)
                let find = this.getChildren(a)
                result = find.text || ''
              }
            }
          }
          let colResult = `${result}`.replace('%', '')
          let val: any = { v: Number(colResult) || colResult }
          let isPer = `${result}`.includes('%')
          if (!isNaN(Number(colResult))) {
            Object.assign(val, { t: 'n' })
            if (isPer) {
              val.v = parseFloat((val.v / 100).toFixed(4))
              Object.assign(val, { z: '0.00%' })
            }
          }
          sheet[this.getFromCode(65 + j) + (i + 1)] = val
          let len = isPer ? 6 : this.getStringLen(result) + 4
          if (len > (sheet['!cols'][j] || { wch: 0 }).wch) {
            sheet['!cols'][j] = { wch: len }
          }
        }
      })
    })
    return sheet
  }
  getChildren(from) {
    let find = from
    do {
      if (find.children && find.children[0]) {
        find = find.children[0]
      } else {
        return find
      }
    } while (true)
  }
  sheet2blob(sheet, sheetName) {
    var workbook = { SheetNames: [sheetName], Sheets: { [sheetName]: sheet } }
    var wopts = { bookType: 'xlsx', bookSST: false, type: 'binary' }
    var wbout = XLSX.write(workbook, wopts)
    var blob = new Blob([this.s2ab(wbout)], {
      type: 'application/octet-stream'
    })
    return blob
  }
  openDownloadDialog(url, saveName) {
    if (typeof url == 'object' && url instanceof Blob) {
      url = URL.createObjectURL(url) // 创建blob地址
    }
    var aLink = document.createElement('a')
    aLink.href = url
    aLink.download = saveName || '' // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
    var event
    if ((window as any).MouseEvent) event = new MouseEvent('click')
    else {
      event = document.createEvent('MouseEvents')
      event.initMouseEvent(
        'click',
        true,
        false,
        window,
        0,
        0,
        0,
        0,
        0,
        false,
        false,
        false,
        false,
        0,
        null
      )
    }
    aLink.dispatchEvent(event)
  }
  s2ab(s) {
    var buf = new ArrayBuffer(s.length)
    var view = new Uint8Array(buf)
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff
    return buf
  }
  private getinitPlatId() {
    if (this.plat_list.length > 1) {
      localStorage.setItem(
        'platId',
        this.plat_list[(this as any).$initIndex].id
      )
      return (this as any).plat_list[(this as any).$initIndex].id
    } else {
      localStorage.setItem('platId', this.plat_list[0].id)
      return (this as any).plat_list[0].id
    }
  }
  private eleToPdf(option?: { ele: any; name: any }) {
    return new Promise((resolve, reject) => {
      setTimeout(async () => {
        let parent: any = document.getElementsByClassName('content-wrapper')[0]
        let ele: any = parent.children[0].children[1]
        let options: any = {
          logging: false,
          width: ele.clientWidth, //dom 原始宽度
          height: ele.clientHeight,
          scrollY: 0,
          scrollX: 0,
          allowTaint: true,
          useCORS: true //允许canvas画布内可以跨域请求外部链接图片, 允许跨域请求。
        }
        html2canvas(ele, options).then(canvas => {
          var contentWidth = ele.clientWidth
          var contentHeight = ele.clientHeight
          var pageData = canvas.toDataURL('image/png', 1.0)
          var pdfX = (contentWidth * 3) / 8
          var pdfY = Math.max((contentHeight * 3) / 8, 900)
          var imgX = pdfX
          var imgY = (imgX * contentHeight) / ele.clientWidth
          var PDF = new jsPDF({
            unit: 'pt',
            format: [pdfX, pdfY]
          })
          PDF.addImage(pageData, 'png', 0, 0, imgX, imgY)
          // @ts-ignore
          PDF.save(
            `${this.$route.meta.title} ${new Date().toLocaleDateString()}.pdf`
          )
          ;(this.$Spin as any).hide()
          resolve(true)
        })
      }, 600)
      this.publicLoading()
    })
  }

  private getCurrentZeroDay() {
    return new Date(new Date().setHours(0, 0, 0, 0))
  }

  private getAllHttpAppid(from) {
    from = from || { platids: [], appids: [] }
    let { platids, app_ids } = from
    let allList: any = []
    if (platids.length == 0) {
      if (app_ids.length == 0) {
        allList = this.app_list.map((cur: any) => cur.appid) || []
      } else {
        allList = [...app_ids]
      }
    } else {
      if (app_ids.length == 0) {
        allList =
          this.app_list
            .filter((el: any) => platids.includes(el.platform))
            .map((cur: any) => cur.appid) || []
      } else {
        allList = [...app_ids]
      }
    }
    return allList
  }
  //计算比
  private calcRate(divisor, dividend, isRound?) {
    let result = 0
    if (dividend) {
      result = divisor / dividend
      if (isRound) {
        result = Math.round((divisor / dividend) * 100) / 100
      }
    }
    return result
  }
  private copyData(item) {
    let result = item
    try {
      result = JSON.parse(JSON.stringify(item))
    } catch (error) {}
    return result
  }
  private rBaseC(key, title, tip, minWidth = 100, custom) {
    let col = { title, key, minWidth, align: 'center' }
    if (tip) {
      Object.assign(col, {
        renderHeader: h => this.renderHeader(h, title, tip)
      })
    }
    if (custom) {
      Object.assign(col, custom)
    }
    return col
  }
  private rPointC(key, title, tip, minWidth = 100, custom) {
    let col = this.rBaseC(key, title, tip, minWidth, {
      render: (h, params) =>
        h('span', this.getCustomFixed(params.row[key] / 10000))
    })
    if (!custom) {
      Object.assign(col, custom)
    }
    return col
  }
  private rRateC(key, title, tip, minWidth = 100, custom) {
    let col = this.rBaseC(key, title, tip, minWidth, {
      render: (h, params) =>
        h('span', (params.row[key] * 100 || 0).toFixed(2) + '%')
    })
    if (!custom) {
      Object.assign(col, custom)
    }
    return col
  }
  private rRBaseC(key, title, tip, width = 100, custom) {
    let col = { title, key, width, align: 'center', resizable: true }
    if (tip) {
      Object.assign(col, {
        renderHeader: h => this.renderHeader(h, title, tip)
      })
    }
    if (custom) {
      Object.assign(col, custom)
    }
    return col
  }
  private rRPointC(key, title, tip, width = 100, custom) {
    let col = this.rBaseC(key, title, tip, width, {
      render: (h, params) =>
        h('span', this.getCustomFixed(params.row[key] / 10000))
    })
    if (custom) {
      Object.assign(col, custom)
    }
    return col
  }
  private rRRateC(key, title, tip, width = 100, custom) {
    let col = this.rBaseC(key, title, tip, width, {
      render: (h, params) =>
        h('span', (params.row[key] * 100 || 0).toFixed(2) + '%')
    })
    if (custom) {
      Object.assign(col, custom)
    }
    return col
  }
  // table列无数据展示
  private renderNilData(h, params) {
    const key = params.column.key
    const row = params.row
    if (row[key] === '' && row[key] !== 0) {
      return h('span', '-')
    } else {
      return h('span', row[key])
    }
  }

  private anyToNumber(val: any, defaultVal: number) {
    if (typeof val == 'number') {
      return val
    } else {
      if (!val) {
        return defaultVal
      } else {
        return Number(val)
      }
    }
  }
  // 渲染金额
  private renderMoney(h, params) {
    const key = params.column.key
    const row = params.row
    const money = row[key]
    if (!money) {
      return h('span', '0.00')
    } else {
      const result = Number(money) / 10000
      return h('span', result.toFixed(2))
    }
  }

  private globalLangList = [
    { value: 0, name: "中文" },
    { value: 1, name: "英文" },
    { value: 2, name: "越南语" },
    { value: 3, name: "泰语" },
    { value: 4, name: "马来语" },
    { value: 5, name: "印尼语" },
    { value: 6, name: "菲律宾语" },
    { value: 7, name: "高棉语" },
    { value: 8, name: "老挝语" },
    { value: 9, name: "缅甸语" },
    { value: 10, name: "印度语" },
    { value: 11, name: "印地语" },
    { value: 12, name: "西班牙语" },
    { value: 13, name: "阿拉伯语" },
    { value: 14, name: "孟加拉语" },
    { value: 15, name: "俄语" },
    { value: 16, name: "葡萄牙语" },
    { value: 17, name: "南斯拉夫语（塞尔维亚-克罗地亚-波斯尼亚-黑山-马其顿语）" },
    { value: 18, name: "法语" },
    { value: 19, name: "巴西（葡萄牙语）" },
    { value: 20, name: "繁体中文" },
  ]

  private langFilter(val) {
    const item = this.globalLangList.find(i => i.value === Number(val))

    return item && item.name || val
  }
}
